export default __webpack_public_path__ + "49e2df7d315d10bb1a2d02f8a0cf185d.png";